/**
 * Room-use navigation scroller — arrows, drag, keep active pill visible.
 * Scoped: [data-room-use-navigation]
 */
(function () {
  'use strict';

  var instances = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (!root || instances.has(root)) return;
    var track = root.querySelector('[data-room-nav-track]');
    var prev = root.querySelector('[data-room-nav-prev]');
    var next = root.querySelector('[data-room-nav-next]');
    if (!track) return;

    var state = {
      track: track,
      prev: prev,
      next: next,
      drag: false,
      startX: 0,
      startScroll: 0,
      moved: false
    };

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 4;
      if (prev) {
        if (!overflow || track.scrollLeft <= 2) prev.setAttribute('hidden', '');
        else prev.removeAttribute('hidden');
      }
      if (next) {
        if (!overflow || track.scrollLeft >= max - 2) next.setAttribute('hidden', '');
        else next.removeAttribute('hidden');
      }
    }

    function scrollByDir(dir) {
      var amount = Math.max(160, Math.floor(track.clientWidth * 0.7));
      track.scrollBy({
        left: dir * amount,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    function keepActiveVisible() {
      var active = track.querySelector('.is-active, [aria-current="true"]');
      if (!active || typeof active.scrollIntoView !== 'function') return;
      active.scrollIntoView({
        inline: 'center',
        block: 'nearest',
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    function onPrev(e) {
      e.preventDefault();
      scrollByDir(-1);
    }
    function onNext(e) {
      e.preventDefault();
      scrollByDir(1);
    }
    function onScroll() {
      window.requestAnimationFrame(updateArrows);
    }

    function onPointerDown(e) {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      state.drag = true;
      state.moved = false;
      state.startX = e.clientX;
      state.startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
    }

    function onPointerMove(e) {
      if (!state.drag) return;
      var dx = e.clientX - state.startX;
      if (Math.abs(dx) > 3) state.moved = true;
      track.scrollLeft = state.startScroll - dx;
    }

    function onPointerUp(e) {
      if (!state.drag) return;
      state.drag = false;
      track.classList.remove('is-dragging');
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err2) {}
    }

    function onClickCapture(e) {
      if (state.moved) {
        e.preventDefault();
        e.stopPropagation();
        state.moved = false;
      }
    }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('click', onClickCapture, true);
    window.addEventListener('resize', updateArrows, { passive: true });

    updateArrows();
    keepActiveVisible();

    state.destroy = function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('pointerdown', onPointerDown);
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', onPointerUp);
      track.removeEventListener('pointercancel', onPointerUp);
      track.removeEventListener('click', onClickCapture, true);
      window.removeEventListener('resize', updateArrows);
    };

    instances.set(root, state);
  }

  function destroy(root) {
    var state = instances.get(root);
    if (state && state.destroy) state.destroy();
    instances.delete(root);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-room-nav-scroller]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    if (e.target.hasAttribute && e.target.hasAttribute('data-room-nav-scroller')) {
      destroy(e.target);
    }
    var nodes = e.target.querySelectorAll('[data-room-nav-scroller]');
    Array.prototype.forEach.call(nodes, destroy);
  });
})();
